/* OK Recs - self-learning upsell and cross-sell. Oliver's Kitchen, 20 Oct 2026.
   Candidates: Shopify recommendations (complementary + related). Ranking: learned attach rates
   from shop metafield ok_recs.model, with one exploration slot so new pairings get tried.
   Signals written for the daily learning job: line item property _ok_rec, cart attribute _ok_seen. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('OkRecsConfig');
  if (!cfgEl || window.__okRecs) return;
  window.__okRecs = true;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var M = C.model || {};
  var PAIRS = M.pairs || {}, GLOBAL = M.global || {}, SEENC = M.seen || {};
  var ROOT = (C.root || '/').replace(/\/?$/, '/');
  var EXPLORE_RATE = typeof M.explore === 'number' ? M.explore : 0.25;
  var PRIOR = 0.05;

  /* ---------- small helpers ---------- */
  function store(kind) {
    var s; try { s = window[kind]; } catch (e) { s = null; }
    return {
      get: function (k, d) { try { var v = s && s.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
      set: function (k, v) { try { s && s.setItem(k, JSON.stringify(v)); } catch (e) {} }
    };
  }
  var LS = store('localStorage'), SS = store('sessionStorage');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var fmt = C.money || '£{{amount}}';
    var n = (Number(cents) || 0) / 100;
    function fix(v, dec, th, dp) {
      var p = v.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[1] ? p[0] + dp + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return fix(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fix(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fix(n, 0, '.', ',');
      return fix(n, 2, ',', '.');
    });
  }

  function img(url, w) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function getJSON(url) {
    var key = 'okr:' + url, hit = SS.get(key, null);
    if (hit && Date.now() - hit.t < 10 * 60 * 1000) return Promise.resolve(hit.d);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { SS.set(key, { t: Date.now(), d: d }); return d; });
  }

  /* Normalise the three product shapes we meet (product .js / recommendations, collection products.json) */
  function norm(p) {
    if (!p || !p.handle) return null;
    var vars = p.variants || [];
    var avail = vars.filter(function (v) { return v.available; });
    var v = avail[0] || vars[0];
    if (!v) return null;
    var cents = function (x) { return typeof x === 'string' ? Math.round(parseFloat(x) * 100) : Number(x || 0); };
    var price = cents(v.price);
    var cmp = cents(v.compare_at_price);
    var image = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || (v.featured_image && v.featured_image.src);
    var type = (p.type || p.product_type || '').toLowerCase();
    return {
      id: p.id, handle: p.handle, title: p.title, url: ROOT + 'products/' + p.handle,
      price: price, compare: cmp > price ? cmp : 0, img: typeof image === 'object' && image ? image.src : image,
      available: p.available !== undefined ? !!p.available && avail.length > 0 : avail.length > 0,
      variantId: (avail[0] || v).id, multi: avail.length > 1,
      gift: /gift.?card/.test(p.handle) || type.indexOf('gift card') > -1
    };
  }

  function recsFor(id, intent, limit) {
    if (!id) return Promise.resolve([]);
    var base = (C.recsUrl || '/recommendations/products');
    return getJSON(base + '.json?product_id=' + id + '&limit=' + limit + '&intent=' + intent)
      .then(function (d) { return (d.products || []).map(norm).filter(Boolean); })
      .catch(function () { return []; });
  }
  function byHandle(h) {
    return getJSON(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(norm).catch(function () { return null; });
  }
  function bestSellers() {
    return getJSON(ROOT + 'collections/' + C.fallback + '/products.json?limit=12')
      .then(function (d) { return (d.products || []).map(norm).filter(Boolean); })
      .catch(function () { return []; });
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { return { items: [], item_count: 0 }; });
  }

  /* ---------- shopper history (personal layer) ---------- */
  function pushHist(handle, id) {
    if (!handle) return;
    var h = LS.get('okrHist', []).filter(function (x) { return x.h !== handle; });
    h.unshift({ h: handle, id: id || null, t: Date.now() });
    LS.set('okrHist', h.slice(0, 8));
  }
  if (C.page === 'product' && C.anchor) pushHist(C.anchor, C.anchorId);

  /* ---------- ranking ---------- */
  function learned(anchors, handle) {
    var best = null;
    anchors.forEach(function (a) {
      var row = PAIRS[a.h];
      if (row && typeof row[handle] === 'number') best = best === null ? row[handle] : Math.max(best, row[handle]);
    });
    if (best !== null) return best;
    if (typeof GLOBAL[handle] === 'number') return GLOBAL[handle] * 0.7;
    return null;
  }

  function rank(anchors, cands, slots, exclude) {
    var seen = {}, pool = [];
    cands.forEach(function (c) {
      var p = c.p;
      if (!p || !p.available || p.gift || exclude[p.handle] || seen[p.handle]) return;
      seen[p.handle] = 1;
      var l = learned(anchors, p.handle);
      var s = (l === null ? PRIOR : l) + PRIOR * 0.5 * c.prior; /* Shopify's own order breaks ties and seeds new stores */
      pool.push({ p: p, s: s, learnedFlag: l !== null });
    });
    pool.sort(function (a, b) { return b.s - a.s; });
    var picks = pool.slice(0, slots).map(function (x) { x.mode = 'm'; return x; });
    /* exploration: sometimes give the last slot to a lightly-tested candidate */
    if (picks.length === slots && pool.length > slots && Math.random() < EXPLORE_RATE) {
      var rest = pool.slice(slots).filter(function (x) { return (SEENC[x.p.handle] || 0) < 60; });
      if (!rest.length) rest = pool.slice(slots);
      var pick = rest[Math.floor(Math.random() * Math.min(rest.length, 6))];
      pick.mode = 'x';
      picks[slots - 1] = pick;
    }
    return picks;
  }

  function gather(anchors, opts) {
    var jobs = [];
    anchors.slice(0, 3).forEach(function (a, i) {
      var w = i === 0 ? 1 : 0.8;
      jobs.push(recsFor(a.id, 'complementary', 6).then(function (l) { return l.map(function (p, j) { return { p: p, prior: w / (1 + j * 0.3) }; }); }));
      jobs.push(recsFor(a.id, 'related', 8).then(function (l) { return l.map(function (p, j) { return { p: p, prior: 0.7 * w / (1 + j * 0.3) }; }); }));
      /* learned pairs Shopify didn't suggest */
      var row = PAIRS[a.h];
      if (row) {
        Object.keys(row).sort(function (x, y) { return row[y] - row[x]; }).slice(0, 3).forEach(function (h) {
          jobs.push(byHandle(h).then(function (p) { return p ? [{ p: p, prior: 0.5 }] : []; }));
        });
      }
    });
    if (opts && opts.fill) {
      jobs.push(bestSellers().then(function (l) { return l.map(function (p, j) { return { p: p, prior: 0.4 / (1 + j * 0.3) }; }); }));
    }
    return Promise.all(jobs).then(function (lists) { return [].concat.apply([], lists); });
  }

  /* resolve anchors that only have handles (blog posts, history without ids) */
  function withIds(list) {
    return Promise.all(list.map(function (a) {
      if (a.id) return a;
      return byHandle(a.h).then(function (p) { return p ? { h: p.handle, id: p.id } : null; });
    })).then(function (l) { return l.filter(Boolean); });
  }

  /* ---------- seen tracking -> cart attribute ---------- */
  var seenTimer;
  function markSeen(placement, anchorH, picks) {
    var s = SS.get('okrSeen', []);
    picks.forEach(function (x) {
      var k = placement + ':' + anchorH + '>' + x.p.handle;
      if (s.indexOf(k) === -1) s.push(k);
    });
    SS.set('okrSeen', s.slice(-60));
    clearTimeout(seenTimer);
    seenTimer = setTimeout(flushSeen, 1500);
  }
  function flushSeen(force) {
    var val = SS.get('okrSeen', []).join(',');
    if (!val || (!force && SS.get('okrSeenW', '') === val)) return Promise.resolve();
    return getCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _ok_seen: val.slice(0, 2000) } })
      }).then(function () { SS.set('okrSeenW', val); });
    }).catch(function () {});
  }

  /* ---------- rendering ---------- */
  function cardHTML(x, i, layout) {
    var p = x.p;
    var price = (p.compare ? '<s>' + money(p.compare) + '</s> ' : '') + '<span>' + money(p.price) + '</span>';
    var action = p.multi
      ? '<a class="okr-card__add okr-card__add--choose" href="' + esc(p.url) + '">Choose</a>'
      : '<button type="button" class="okr-card__add" data-okr-add="' + i + '" aria-label="Add ' + esc(p.title) + ' to basket">+ Add</button>';
    var w = layout === 'grid' ? 360 : 160;
    return '<div class="okr-card">' +
      '<a class="okr-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
      (p.img ? '<img src="' + esc(img(p.img, w)) + '" alt="" loading="lazy" width="' + (w / 2) + '" height="' + (w / 2) + '">' : '') + '</a>' +
      '<div class="okr-card__body"><a class="okr-card__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="okr-card__price">' + price + '</span></div>' + action + '</div>';
  }

  function render(host, placement, title, sub, anchors, picks, layout) {
    if (!picks.length) { host.hidden = true; host.innerHTML = ''; return; }
    var anchorH = anchors[0] ? anchors[0].h : 'none';
    host.hidden = false;
    host.className = 'okr okr--' + placement + ' okr--' + layout;
    host.setAttribute('aria-label', title);
    host.innerHTML =
      '<div class="okr__head"><h2 class="okr__title">' + esc(title) + '</h2>' +
      (sub ? '<p class="okr__sub">' + esc(sub) + '</p>' : '') + '</div>' +
      '<div class="okr__list">' + picks.map(function (x, i) { return cardHTML(x, i, layout); }).join('') + '</div>' +
      '<p class="okr__status" role="status" aria-live="polite"></p>';
    host.querySelectorAll('[data-okr-add]').forEach(function (btn) {
      btn.addEventListener('click', function () { add(btn, picks[+btn.getAttribute('data-okr-add')], placement, anchorH, host); });
    });
    markSeen(placement, anchorH, picks);
  }

  function add(btn, x, placement, anchorH, host) {
    if (btn.disabled) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding...';
    var status = host.querySelector('.okr__status');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: x.p.variantId, quantity: 1, properties: { _ok_rec: placement + '|' + anchorH + '|' + x.mode } }] })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    }).then(function (d) {
      btn.textContent = 'Added';
      btn.classList.add('is-added');
      if (status) status.textContent = x.p.title + ' added to your basket.';
      pushHist(x.p.handle, x.p.id);
      var item = (d.items && d.items[0]) || d;
      flushSeen(true);
      try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
      if (placement !== 'drawer') {
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } })); } catch (e) {}
      }
      setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-added'); }, 2500);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = label;
      if (status) status.textContent = (err && err.description) || 'Could not add that one - have a look on its page.';
    });
  }

  function host(id) {
    var el = document.getElementById(id);
    if (!el) { el = document.createElement('section'); el.id = id; el.hidden = true; }
    return el;
  }

  /* ---------- placements ---------- */
  function productPage() {
    if (!C.anchor || !C.anchorId) return;
    var form = document.querySelector('#MainContent form[action*="/cart/add"]:not([data-okr])');
    var h = host('OkRecsPdp');
    if (form) {
      var block = form.closest('.product-block') || form;
      block.parentNode.insertBefore(h, block.nextSibling);
    } else {
      document.getElementById('MainContent').appendChild(h);
    }
    var anchors = [{ h: C.anchor, id: C.anchorId }];
    getCart().then(function (cart) {
      var ex = {}; ex[C.anchor] = 1;
      (cart.items || []).forEach(function (i) { ex[i.handle] = 1; });
      return gather(anchors, { fill: true }).then(function (c) {
        render(h, 'pdp', 'Goes well with', 'Pop it in with one tap', anchors, rank(anchors, c, 3, ex), 'list');
      });
    });
  }

  function cartPlacement(placement, mountFn) {
    var h = host(placement === 'drawer' ? 'OkRecsDrawer' : 'OkRecsCart');
    if (!mountFn(h)) return null;
    var busy = false, again = false;
    function run() {
      if (busy) { again = true; return; }
      busy = true;
      getCart().then(function (cart) {
        var items = cart.items || [];
        if (!items.length) { h.hidden = true; h.innerHTML = ''; return; }
        var ex = {}, anchors = [];
        items.forEach(function (i) {
          ex[i.handle] = 1;
          if (!anchors.some(function (a) { return a.h === i.handle; })) anchors.push({ h: i.handle, id: i.product_id });
        });
        return gather(anchors, { fill: true }).then(function (c) {
          render(h, placement, 'Complete the kit', null, anchors, rank(anchors, c, placement === 'drawer' ? 3 : 4, ex), placement === 'drawer' ? 'list' : 'grid');
        });
      }).catch(function () {}).then(function () {
        busy = false;
        if (again) { again = false; run(); }
      });
    }
    run();
    return run;
  }

  function drawer() {
    var products = document.querySelector('#CartDrawer [data-products]');
    if (!products) return;
    var run = cartPlacement('drawer', function (h) {
      products.parentNode.insertBefore(h, products.nextSibling);
      return true;
    });
    if (!run) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 250); })
      .observe(products, { childList: true });
  }

  function cartPage() {
    var form = document.getElementById('CartPageForm');
    if (!form) return;
    cartPlacement('cart', function (h) { form.parentNode.insertBefore(h, form.nextSibling); return true; });
  }

  function articlePage() {
    var handles = (C.article || []).filter(Boolean);
    var h = host('OkRecsArticle');
    var stop = document.querySelector('.cb-signoff') || document.querySelector('#MainContent article');
    if (stop && stop.classList.contains('cb-signoff')) stop.parentNode.insertBefore(h, stop);
    else (stop || document.getElementById('MainContent')).appendChild(h);
    var hist = LS.get('okrHist', []).slice(0, 2).map(function (x) { return { h: x.h, id: x.id }; });
    var list = handles.map(function (x) { return { h: x, id: null }; }).concat(hist);
    withIds(list).then(function (anchors) {
      return Promise.all([gather(anchors, { fill: true }), Promise.all(handles.slice(0, 2).map(byHandle))]).then(function (r) {
        /* the post's own featured products always lead, the learned picks fill the rest */
        var ex = {};
        var front = r[1].filter(function (p) { return p && p.available && !p.gift; })
          .map(function (p) { ex[p.handle] = 1; return { p: p, mode: 'f' }; });
        var picks = rank(anchors, r[0], 4 - front.length, ex);
        render(h, 'article', 'Kit for this one', 'Tried, tested and family-approved', anchors, front.concat(picks), 'grid');
      });
    }).catch(function () {});
  }

  function strip() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var h = host('OkRecsStrip');
    main.appendChild(h);
    var hist = LS.get('okrHist', []).slice(0, 3).map(function (x) { return { h: x.h, id: x.id }; });
    withIds(hist).then(function (anchors) {
      return getCart().then(function (cart) {
        var ex = {};
        (cart.items || []).forEach(function (i) { ex[i.handle] = 1; });
        anchors.forEach(function (a) { ex[a.h] = 1; });
        if (anchors.length) {
          return gather(anchors, { fill: true }).then(function (c) {
            render(h, 'strip', 'Picked for you', 'Based on what you have been eyeing up', anchors, rank(anchors, c, 4, ex), 'grid');
          });
        }
        return bestSellers().then(function (l) {
          var c = l.map(function (p, j) { return { p: p, prior: 1 / (1 + j * 0.3) }; });
          render(h, 'strip', 'Kitchen favourites', 'The kit other cooks keep coming back for', [], rank([], c, 4, ex), 'grid');
        });
      });
    }).catch(function () {});
  }

  function start() {
    drawer();
    var pg = C.page;
    if (pg === 'product') productPage();
    else if (pg === 'cart') cartPage();
    else if (pg === 'article') articlePage();
    else strip();
    /* make sure what was shown reaches the order before checkout */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || (f.id !== 'CartDrawerForm' && f.id !== 'CartPageForm')) return;
      var val = SS.get('okrSeen', []).join(',');
      if (!val || SS.get('okrSeenW', '') === val || !navigator.sendBeacon) return;
      try {
        navigator.sendBeacon(ROOT + 'cart/update.js', new Blob(
          ['attributes%5B_ok_seen%5D=' + encodeURIComponent(val.slice(0, 2000))],
          { type: 'application/x-www-form-urlencoded' }));
      } catch (err) {}
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
